export default function PageHeader() {
  return (
    <section className="bg-gradient-to-b from-white to-light-cyan pt-32 pb-16 md:pb-20 relative overflow-hidden">
      {/* Decorative Wave */}
      <div className="absolute top-32 right-10 w-48 h-48 opacity-10">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 50 Q 25 30, 50 50 T 100 50 T 150 50" stroke="currentColor" fill="none" strokeWidth="4" className="text-tropical-teal" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold text-charcoal mb-6">
          Pool Services in Miami
        </h1>
        <p className="text-xl md:text-2xl text-slate-gray font-light max-w-3xl mx-auto">
          From small repairs to full upgrades—Miami Pool Service has you covered.
        </p>
      </div>
    </section>
  );
}